
export default data => JSON.parse(JSON.stringify(data));



// WEBPACK FOOTER //
// ./src/utilities/deepCopy.js